// NEW_FILE_JUSTIFIED: Payment sub-section for consolidated insurance settings page — extracted from PaymentSettingsDialog
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { PaymentGeneralTab } from '@/components/insurance/PaymentGeneralTab';
import { PaymentEmailTemplateTab } from '@/components/insurance/PaymentEmailTemplateTab';
import { PaymentSmsTemplateTab } from '@/components/insurance/PaymentSmsTemplateTab';
import { PaymentCompanyEmailTemplateTab } from '@/components/insurance/PaymentCompanyEmailTemplateTab';
import type { IInsuranceSettingsPaymentSectionProps } from '@/@types/insurance';

const PAYMENT_EMAIL_VARIABLES = [
  'customerName',
  'policyNumber',
  'insuranceType',
  'invoiceStatus',
  'partialAmount',
  'orgName',
];

const PAYMENT_SMS_VARIABLES = [
  'customerName',
  'policyNumber',
  'insuranceType',
  'invoiceStatus',
  'orgName',
];

const PAYMENT_COMPANY_VARIABLES = ['companyName', 'employeeList', 'orgName'];

export function InsuranceSettingsPaymentSection({
  paymentState,
  paymentDispatch,
}: IInsuranceSettingsPaymentSectionProps) {
  return (
    <div className="space-y-6 p-6">
      <PaymentGeneralTab
        gracePeriodDays={paymentState.gracePeriodDays}
        smsFallbackDays={paymentState.smsFallbackDays}
        notificationMode={paymentState.notificationMode}
        onGracePeriodDaysChange={days =>
          paymentDispatch({ type: 'SET_GRACE_PERIOD_DAYS', value: days })
        }
        onSmsFallbackDaysChange={days =>
          paymentDispatch({ type: 'SET_SMS_FALLBACK_DAYS', value: days })
        }
        onNotificationModeChange={mode =>
          paymentDispatch({ type: 'SET_NOTIFICATION_MODE', value: mode })
        }
      />

      <Tabs defaultValue="email-template">
        <TabsList className="grid w-full grid-cols-3">
          <TabsTrigger value="email-template">Email Template</TabsTrigger>
          <TabsTrigger value="sms-template">SMS Template</TabsTrigger>
          <TabsTrigger value="company-template">Company Template</TabsTrigger>
        </TabsList>

        <TabsContent value="email-template" className="mt-4">
          <PaymentEmailTemplateTab
            template={paymentState.emailTemplate}
            onTemplateChange={t => paymentDispatch({ type: 'SET_EMAIL_TEMPLATE', value: t })}
            availableVariables={PAYMENT_EMAIL_VARIABLES}
            templateType="email"
          />
        </TabsContent>

        <TabsContent value="sms-template" className="mt-4">
          <PaymentSmsTemplateTab
            template={paymentState.smsTemplate}
            onTemplateChange={t => paymentDispatch({ type: 'SET_SMS_TEMPLATE', value: t })}
            availableVariables={PAYMENT_SMS_VARIABLES}
            templateType="sms"
          />
        </TabsContent>

        <TabsContent value="company-template" className="mt-4">
          <PaymentCompanyEmailTemplateTab
            template={paymentState.companyEmailTemplate}
            onTemplateChange={t =>
              paymentDispatch({ type: 'SET_COMPANY_EMAIL_TEMPLATE', value: t })
            }
            availableVariables={PAYMENT_COMPANY_VARIABLES}
            templateType="company_email"
          />
        </TabsContent>
      </Tabs>
    </div>
  );
}
